import { c as _c } from "react/compiler-runtime";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import React from "react";
import ValidationError from "../submission/ui/ValidationError";
interface TraitWrapperProps {
  readonly label: string;
  readonly readOnly?: boolean | undefined;
  readonly children: React.ReactNode;
  readonly isBoolean?: boolean | undefined;
  readonly className?: string | undefined;
  readonly error?: string | null | undefined;
  readonly id?: string | undefined;
  readonly isFieldFilled?: boolean | undefined;
}
export const TraitWrapper: React.FC<TraitWrapperProps> = t0 => {
  const $ = _c(46);
  const {
    label,
    readOnly: t1,
    children,
    isBoolean: t2,
    className,
    error,
    id,
    isFieldFilled: t3
  } = t0;
  const readOnly = t1 === undefined ? false : t1;
  const isBoolean = t2 === undefined ? false : t2;
  const isFieldFilled = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== id || $[1] !== label) {
    t4 = id ?? `field-${label.toLowerCase().replace(/\s+/g, "-")}`;
    $[0] = id;
    $[1] = label;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const fieldId = t4;
  const errorId = error ? `${fieldId}-error` : undefined;
  const hasError = !!error && !readOnly;
  let labelClassName = "tw-text-iron-300 group-focus-visible-within:tw-text-primary-400";
  if (readOnly) {
    labelClassName = "tw-text-iron-500";
  } else {
    if (hasError) {
      labelClassName = "tw-text-red-400";
    }
  }
  if (isBoolean) {
    const t5 = `tw-group tw-relative ${className ?? ""}`;
    let t6;
    if ($[3] !== fieldId || $[4] !== label) {
      t6 = <label htmlFor={fieldId} className="tw-w-40 tw-flex-shrink-0 tw-cursor-pointer tw-text-sm tw-font-medium tw-text-iron-300">{label}</label>;
      $[3] = fieldId;
      $[4] = label;
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    let t7;
    if ($[6] !== children) {
      t7 = <div className="tw-max-w-xs tw-flex-1">{children}</div>;
      $[6] = children;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
      t8 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">{t6}{t7}</div>;
      $[8] = t6;
      $[9] = t7;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    let t9;
    if ($[11] !== t5 || $[12] !== t8) {
      t9 = <div className={t5}>{t8}</div>;
      $[11] = t5;
      $[12] = t8;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    return t9;
  }
  let t5;
  if ($[14] !== className) {
    t5 = className?.includes("tw-pb-");
    $[14] = className;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const hasPaddingOverride = t5;
  const basePadding = hasPaddingOverride ? "" : "tw-pb-8";
  const t6 = `tw-group tw-relative ${basePadding} ${className ?? ""}`;
  const t7 = `tw-absolute -tw-top-2 tw-left-3 tw-z-10 tw-bg-iron-900 tw-px-1 tw-text-xs tw-font-medium tw-transition-all ${labelClassName}`;
  let t8;
  if ($[16] !== fieldId || $[17] !== label || $[18] !== t7) {
    t8 = <label htmlFor={fieldId} className={t7}>{label}</label>;
    $[16] = fieldId;
    $[17] = label;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== children || $[21] !== errorId || $[22] !== fieldId || $[23] !== hasError) {
    let t10;
    if ($[25] !== errorId || $[26] !== fieldId || $[27] !== hasError) {
      t10 = child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            id: fieldId,
            "aria-invalid": hasError,
            "aria-describedby": errorId,
            ...(child.props || {})
          } as any);
        }
        return child;
      };
      $[25] = errorId;
      $[26] = fieldId;
      $[27] = hasError;
      $[28] = t10;
    } else {
      t10 = $[28];
    }
    t9 = React.Children.map(children, t10);
    $[20] = children;
    $[21] = errorId;
    $[22] = fieldId;
    $[23] = hasError;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[29] !== hasError || $[30] !== isFieldFilled) {
    t10 = isFieldFilled && !hasError && <div className="tw-pointer-events-none tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-transform"><CheckCircleIcon className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-emerald-500" /></div>;
    $[29] = hasError;
    $[30] = isFieldFilled;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t9) {
    t11 = <div className="tw-relative tw-rounded-xl tw-bg-iron-950 tw-transition-all tw-duration-200">{t9}{t10}</div>;
    $[32] = t10;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t11 || $[36] !== t8) {
    t12 = <div className="tw-relative">{t8}{t11}</div>;
    $[35] = t11;
    $[36] = t8;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== error || $[39] !== errorId || $[40] !== hasPaddingOverride) {
    t13 = hasPaddingOverride ? <ValidationError error={error} id={errorId} className="tw-mt-1" /> : <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0"><ValidationError error={error} id={errorId} className="tw-mt-0" /></div>;
    $[38] = error;
    $[39] = errorId;
    $[40] = hasPaddingOverride;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== t12 || $[43] !== t13 || $[44] !== t6) {
    t14 = <div className={t6}>{t12}{t13}</div>;
    $[42] = t12;
    $[43] = t13;
    $[44] = t6;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  return t14;
};